import {
  FluidIconKey,
  FluidScrollSpyOptions,
  FluidSearchOptions,
  FluidStatefulTableConfig,
  FluidStateStrategy,
} from '@lmig/fluid-core';

export const defaultSearchOptions = (
  searchableDataPoints: string[]
): FluidSearchOptions => ({
  dynamicSearch: false,
  searchableColumns: searchableDataPoints,
  debounceTime: 500,
  searchBox: {
    placeholder: 'Search...',
  },
  searchButton: {
    label: 'Search',
    iconBefore: {
      key: FluidIconKey.SEARCH,
    },
  },
  excludeFiltered: false,
  retainFiltersOnClear: false,
});

export const defaultScrollOptions: FluidScrollSpyOptions = {
  enableScrollSpy: false,
  scrollPosition: 0,
  scrollThrottle: 500,
  enableScrollState: false,
  scrollDelay: 2000,
};

export const defaultStatefulOptions = (
  stateful: boolean
): FluidStatefulTableConfig => ({
  sort: {
    enabled: stateful ?? false,
    strategy: FluidStateStrategy.LOCAL,
  },
  filters: {
    enabled: stateful ?? false,
    strategy: FluidStateStrategy.LOCAL,
  },
  columnVisibility: {
    enabled: stateful ?? false,
    strategy: FluidStateStrategy.LOCAL,
  },
  scroll: {
    enabled: stateful ?? false,
    strategy: FluidStateStrategy.LOCAL,
  },
});
